import { Roles } from "../constants/roles";
import { FormBase } from "../util/form-base-form";

export class LikeForm extends FormBase {
    public isLiked(button: HTMLElement): boolean {
        return button.dataset.isLiked === "true";
    }

    public isBusy(button: HTMLElement): boolean {
        const isDisabled = button instanceof HTMLButtonElement && button.disabled;
        return isDisabled || button.classList.contains("loading");
    }

    public getCountElement(button: HTMLElement): HTMLElement | null {
        return this.queryElement(button, `[data-role="${Roles.LIKE_COUNT}"]`, HTMLElement);
    }

    public getIconElement(button: HTMLElement): HTMLElement | null {
        return this.queryElement(button, `[data-role="${Roles.LIKE_ICON}"]`, HTMLElement);
    }

    public getLikesCount(button: HTMLElement): number {
        const countElement = this.getCountElement(button);
        if (!(countElement instanceof HTMLElement)) return 0;
        const count = Number.parseInt(countElement.textContent || "0", 10);
        return Number.isNaN(count) ? 0 : count;
    }

    public isInElementModal(button: HTMLElement): boolean {
        return !!this.closest(button, `[data-role="${Roles.ELEMENT_MODAL}"]`, HTMLElement);
    }

    public getModalLikeButton(postId: number): HTMLElement | null {
        const modalBody = this.queryElement(
            document,
            `[data-role="${Roles.ELEMENT_MODAL}"] [data-role="${Roles.ELEMENT_MODAL_BODY}"]`,
            HTMLElement,
        );
        if (!(modalBody instanceof HTMLElement)) return null;
        return this.queryElement(
            modalBody,
            `[data-role="${Roles.LIKE_BUTTON}"][data-post-id="${postId}"]`,
            HTMLElement,
        );
    }

    public getParentWindowLikeButton(postId: number): HTMLElement | null {
        if (typeof window === "undefined" || !window.opener) return null;

        try {
            if (window.opener.closed) return null;
        } catch (_error) {
            return null;
        }

        try {
            return this.queryElement(
                window.opener.document,
                `[data-role="${Roles.LIKE_BUTTON}"][data-post-id="${postId}"]`,
                HTMLElement,
            );
        } catch (_error) {
            return null;
        }
    }
}
